export default "__VITE_ASSET__BPrz_$v8__"